import { Button, Icon, Link, SpaceBetween } from '@amzn/awsui-components-core';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';

interface Props {
  isButton?: boolean;
}

const DiagramGuidelinesDeck = (props: Props) => {
  const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

  const renderDiagramGuidelinesDeck = async () => {
    const { url } = await mplServiceClient.getDiagramGuidelinesDeck();
    window.open(url, '_blank');
  };

  return props.isButton ? (
    <Button iconName="download" onClick={renderDiagramGuidelinesDeck}>
      How to build architecture diagrams
    </Button>
  ) : (
    <Link onFollow={renderDiagramGuidelinesDeck}>
      <SpaceBetween size={'xxs'} direction="horizontal">
        <Icon name="download" />
        How to build architecture diagrams
      </SpaceBetween>
    </Link>
  );
};

export default DiagramGuidelinesDeck;
